import './MainCategoryHeader.scss';
import images from '../../assets/images';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getScreenDimensions } from '../../utils/helper';
import MobileHeader from '../MobileHeader/MobileHeader';

interface propsType{
    navigateLocation: string;
}
const MainCategoryHeader:FC<propsType> = ({navigateLocation}) => {
    const {exitIcon} = images;
    const navigate = useNavigate();
    const location = useLocation();

    const categoryName = () => {
        if(location.pathname.includes('ebooks')){
            return 'E-Books';
        }else if(location.pathname.includes('images')){
            return 'Images';
        }else if(location.pathname.includes('podcast')){
            return 'Podcast';
        }else if(location.pathname.includes('videos')){
            return 'Syndicated Videos';
        }
      }

  return (
    <div className='outermainCategoryHeaderContainer'>
    <div className='mainCategoryHeaderContainer'>
        <div className='backIconContainer' onClick={() => {navigate(navigateLocation)}}>
            <img src={exitIcon} alt='backIcon' className='backIcon'/>
        </div>
        <div className='categoryName'>
             {categoryName()}
        </div>
    </div>
    {getScreenDimensions()?.isMobileScreen && <MobileHeader />}
    </div>
  )
}

export default MainCategoryHeader;
